module.exports = __webpack_public_path__ + "img/406.11ec5e93.png";